import type { Address } from '@/modules/cart/domain/Cart';

export const isShippingAddressComplete = (address: Address) => {
  if (!address) return false;
  if (!address?.firstName) return false;
  if (!address?.lastName) return false;
  if (!address?.phone) return false;
  if (!address?.commune) return false;
  if (!address?.region) return false;
  if (!address?.streetName) return false;
  return true;
};

export default isShippingAddressComplete;
